import { useSelector } from 'react-redux'
import { RootState } from 'types'

export const useLoggedIn = () => useSelector(({ auth }: RootState) => Boolean(auth))
